import React from 'react';
import { CategoryItem } from '../../../shared/types';
import { useQuery } from '@apollo/react-hooks';
import FeaturedCategoryCardListView from '../../ui/FeaturedCategoryCardListView';
import SectionHeader from '../../ui/SectionHeader';
import { SHORT_CATEGORIES } from '../../../gql/categories';
import { useOnDataLoaded } from '../../hooks/use-on-data-loaded';

interface ExploreBySectorProps {
	className?: string;
	onDataLoaded?: () => void;
	hideTitle?: boolean;
}

const ExploreBySector = (props: ExploreBySectorProps) => {
	const { data, loading } = useQuery(SHORT_CATEGORIES, { fetchPolicy: 'network-only' });
	useOnDataLoaded(loading, props.onDataLoaded);

	if (loading) return <></>;
	if (!data) return null;

	const categories = ((data.categories ?? []) as CategoryItem[]).filter(x => x.isFeatured);

	return (
		<>
			{!props.hideTitle &&
				<SectionHeader
					id="for-you-sector-section-header"
					title="Browse by sector"
					subtitle="All our publications grouped by sector." />
			}
			<div className={props?.className}>
				<FeaturedCategoryCardListView
					items={
						categories.sort((a, b) =>
							a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
					}
				/>
			</div>
		</>
	);
}

export default ExploreBySector;
